export function challengeReadiness(clan, attendance, user) {
  const count = Number(attendance?.summary?.count || 0);
  const isOperator = Boolean(user?.clan_id && user.clan_id === clan?.id &&
    (clan?.leader_id === user?.id || clan?.vice_leader_ids?.includes(user?.id)));
  const isCheckedIn = Boolean(attendance?.checked_in?.some(p => p.id === user?.id));
  const administrator = user?.role === "admin" || user?.role === "owner";
  const canManage = administrator || (isOperator && isCheckedIn);
  const operatorReason = administrator ? "" : !isOperator ? "إدارة التحديات متاحة لقائد الكلان أو نائبه فقط" :
    !isCheckedIn ? "يجب أن يكون منفّذ الطلب، القائد أو النائب، محضّراً لإدارة التحدي" : "";
  const reason = count < 6 ? `نقص المحضّرين: ${count}/6؛ الإرسال والقبول يتطلبان 6 لاعبين محضّرين على الأقل` : operatorReason;
  return {count, isOperator, isCheckedIn, canManage, canSend:canManage && count >= 6, operatorReason, reason};
}
